/**
 * Pro /join analytics (plan 476 M3). Allowlist props only: never an email,
 * license, name, code, or token. `agent.signed_up` stays server-side only.
 * Builders return fixed-shape events for the shared `captureEvent` seam.
 */
import type { CaptureEvent } from "./capture-event";

/** Refusal codes a join/validate can return; anything else is reported as `other`. */
export const JOIN_REJECT_CODES = [
  "invalid_professional_credential",
  "invalid_campaign_credential",
  "professional_credential_required",
  "professional_credential_conflict",
  "service_area_unresolvable",
  "campaign_cap_reached",
  "consumer_account_exists",
  "invitation_pending",
] as const;

export type JoinRejectCode = (typeof JOIN_REJECT_CODES)[number] | "other";

export function joinViewed(): CaptureEvent {
  return { event: "agent.join_viewed", props: {} };
}

export function joinSubmitted(): CaptureEvent {
  return { event: "agent.join_submitted", props: {} };
}

export function joinRejected(code: string | undefined): CaptureEvent {
  const known = (JOIN_REJECT_CODES as readonly string[]).includes(code ?? "");
  return {
    event: "agent.join_rejected",
    props: { code: (known ? code : "other") as JoinRejectCode },
  };
}

export function joinSucceeded(lane: "open" | "code" | "referral"): CaptureEvent {
  return { event: "agent.join_succeeded", props: { lane } };
}

export function onboardingOfferSaved(tier: string): CaptureEvent {
  return { event: "agent.onboarding_offer_saved", props: { tier } };
}

export function onboardingOfferSkipped(): CaptureEvent {
  return { event: "agent.onboarding_offer_skipped", props: {} };
}
